/* Username rules and profile toggles
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 921-951.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { publish, saveProfile, unpublish } from './community.js'
import { render } from './render.js'
import { $, state, toast } from './state.js'
import { gateScreen } from './views-auth.js'

/* ══ ⚠⚠⚠ `reportPublish` AND `plural` WERE DELETED HERE ═════════════
 * Phase 4 Step 7 bullet 3, 2026-08-28, along with the `publishAllPhotos`
 * and `clearPubPhotos` call sites they served.
 *
 * ⚠ THEY WERE A REAL FIX AND THEY ARE BEING RETIRED, NOT REVERTED.
 * `946aae7` (2026-08-26) made an incomplete publish say so out loud
 * instead of swallowing it — the fix Jesse asked for by name after the
 * three bugs of 2026-08-25. **There is now no publish of photographs to
 * be incomplete about.** Publishing is `is_public` on the profile row;
 * the bytes stay in R2 and a stranger reads them through the batch
 * route. A report with nothing to report would be worse than none.
 *
 * ⚠⚠ WHAT IS GENUINELY GONE WITH IT: the toast that named a partial
 * publish, and the console warning that listed the omitted slots. If a
 * stranger ever sees fewer photographs than they should, **the evidence
 * is now server-side** — `photo-batch: dropped <id> — <why>` in the
 * Function log — and no longer in the collector's own console. That is
 * the cost of the trade and it is stated rather than glossed. */

const BADWORDS=["fuck","shit","bitch","cunt","nigger","nigga","faggot","retard","rape","rapist","nazi","hitler","slut","whore","pussy","asshole","spic","chink","kike","wetback","tranny","molest","pedo"];
function badName(u){return BADWORDS.some(w=>u.includes(w));}
const YEAR_MS=365*24*60*60*1000;
function daysLeft(){return Math.ceil((YEAR_MS-(Date.now()-state.usernameSetAt))/86400000);}
async function setUsername(v){
  const clean=(v||"").toLowerCase().replace(/[^a-z0-9_]/g,"").slice(0,20);
  if(clean&&badName(clean)){toast("Please choose a different username");state.editingName=true;render();const i=$("unameInput");if(i)i.focus();return;}
  const old=state.username;
  if(clean===old||!clean){state.editingName=false;render();return;}
  if(old&&state.usernameSetAt&&(Date.now()-state.usernameSetAt)<YEAR_MS){
    const d=daysLeft();toast("Usernames can only change once a year — "+d+" day"+(d!==1?"s":"")+" to go");state.editingName=false;render();return;
  }
  state.username=clean;state.usernameSetAt=Date.now();state.editingName=false;saveProfile();
  /* ══ ⚠⚠⚠ THE DELETE-THEN-CANNOT-RESTORE LIVED HERE AND NO LONGER CAN
   * A rename used to clear the OLD `pubph:` namespace and republish into
   * the new one; a slot the republish could not write was simply gone.
   * `946aae7` fixed the ORDER — write first, clear only on a complete
   * republish. **Step 7 bullet 3 removed the thing being ordered.**
   *
   * ⚠ A RENAME CANNOT TOUCH A PHOTOGRAPH AT ALL NOW, AND THAT IS
   * STRUCTURAL RATHER THAN CAREFUL: R2 objects are keyed by OWNER ID,
   * not by username (`objectKeyFor`, `photo-delivery.js`). The username
   * is not in the path, so changing it moves nothing and orphans
   * nothing. */
  if(state.isPublic&&clean){
    publish();
    if(old&&old!==clean)unpublish(old);
  }
  render();
}
document.addEventListener("click",async e=>{
  const v=e.target.closest("[data-viewuser],[data-navback],[data-pubnote],[data-togglepublic],[data-editname]");
  if(!v)return;
  if("viewuser"in v.dataset){state.viewUser=v.dataset.viewuser;state.screen="pubprofile";render();}
  /* ⚠⚠ STEP 9, 2026-08-29. `state.viewUser` IS DELIBERATELY LEFT ALONE —
   * the note detail belongs to the profile already being viewed, and
   * `vPublicNote` finds its note inside that profile. Setting it here
   * would be a second source of truth for whose collection this is.
   *
   * ⚠ AND NOTHING RESETS `pSearch` / `pType` / `pDenom` / `pSort`, WHICH
   * IS THE POINT: `data-navback="pubprofile"` re-renders the profile with
   * the same search and filters the collector left it in. Clearing them
   * on the way in would silently undo their filtering when they came
   * back — a per-tap cost paid on the screen they were browsing. */
  /* ⚠⚠⚠ BOTH BRANCHES CLEAR `pubZoom`, AND LEAVING IT SET WOULD BE THE
   * WORST KIND OF BUG THIS SCREEN CAN HAVE. It names an open enlarge over
   * ONE side of ONE note; carrying it through a navigation would re-open
   * the viewer on the NEXT note the collector taps, showing them a
   * 6000px photograph they did not ask for — and, because
   * `hydratePhotos` requests `archive` whenever it is set, spending the
   * archive tier's megabytes on a tap that was meant to be a cheap one.
   * Neither branch below can reach a screen where an open viewer is
   * correct: going back leaves the note entirely, and opening another
   * note replaces the subject the viewer was showing. */
  else if("pubnote"in v.dataset){state.pubZoom=null;state.pubNote=v.dataset.pubnote;state.screen=gateScreen("pubnote");render();}
  else if("navback"in v.dataset){state.pubZoom=null;state.screen=v.dataset.navback;render();}
  else if("editname"in v.dataset){
    if(state.username&&state.usernameSetAt&&(Date.now()-state.usernameSetAt)<YEAR_MS){const d=daysLeft();toast("Username is locked — one change a year ("+d+" day"+(d!==1?"s":"")+" left)");return;}
    state.editingName=true;render();const i=$("unameInput");if(i){i.focus();try{i.select();}catch(_){}}}
  else if("togglepublic"in v.dataset){
    if(!state.username){toast("Choose a username first");state.editingName=true;render();return;}
    state.isPublic=!state.isPublic;saveProfile();
    /* ⚠⚠ GOING PRIVATE NO LONGER DELETES ANY BYTES, AND THAT IS THE ONE
     * BEHAVIOURAL CHANGE IN THIS PASS WORTH LOOKING AT TWICE. "Private
     * means hidden" was enforced by deleting the published copies; there
     * are no published copies now, so it is enforced by
     * `public_holdings` refusing the read to anyone but the owner.
     *
     * ⚠ THE PROMISE IS THE SAME AND THE ENFORCEMENT MOVED — from bytes
     * this code controls to a WHERE clause in `db/002` that `rls-check`
     * proves against the real database. Re-run it after any change to
     * that view, because it now carries a promise to the collector on
     * its own. */
    if(state.isPublic){
      publish();
      toast("Public — collectors can now find you");
    }else{unpublish();toast("Private — hidden from Community");}
    render();
  }
});

export {
  setUsername,
}
